import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScoreEvolutionStat } from "@/types/admin.types";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

interface ScoreEvolutionChartProps {
  data: ScoreEvolutionStat[];
}

export function ScoreEvolutionChart({ data }: ScoreEvolutionChartProps) {
  const chartData = data.map((item) => ({
    ...item,
    avg_score: Math.min(item.avg_score, 10),
    original_score: item.avg_score, // Keep original for tooltip if needed
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-medium">Average Score</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="date"
                tickFormatter={(value) =>
                  new Date(value).toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                  })
                }
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                domain={[0, 10]}
                tickLine={false}
                axisLine={false}
                allowDecimals={false}
              />
              <Tooltip
                contentStyle={{
                  borderRadius: "8px",
                  border: "none",
                  boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                }}
                formatter={(value: number, name: string, props: any) => [
                  props.payload.original_score.toFixed(2),
                  "avg_score",
                ]}
              />
              <Line
                type="monotone"
                dataKey="avg_score"
                stroke="#1e40af"
                strokeWidth={2}
                dot={{ r: 4, fill: "#1e40af" }}
                activeDot={{ r: 6 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
}
